import React, {useState} from 'react';
import axios from 'axios';
import { API_BASE_URL, fetchData} from './Common';
import './TableViewer.css';
import { ReactComponent as CopyIcon } from '../icons/home/copy.svg';
import { ReactComponent as SaveIcon } from '../icons/home/save.svg';
import { ReactComponent as TrashIcon } from '../icons/home/trash.svg';
import { ReactComponent as ExportIcon } from '../icons/home/export.svg';
import { ReactComponent as PlusIcon } from '../icons/plus.svg';
import { ReactComponent as MinusIcon } from '../icons/minus.svg';


function TableViewer({ tableColumnData,setIsDuplicating,setSpinnerMessage, setTableColumnData, isTablesLoaded, setIsTableColumnDataLoaded, setTables, tables, selectedTableId, onSave, onDuplicate, onExport, onDelete, projectId }) {

  const [selectedColumnId, setSelectedColumnId] = useState(null);
  const [pivotColumnId, setPivotColumnId] = useState(null);
  const [groupingColumnId, setGroupingColumnId] = useState(null);
  const [grouping, setGrouping] = useState(true);
  const [method, setMethod] = useState(null);
  const [selectedOperator, setSelectedOperator] = useState(null);
  const [customValue, setCustomValue] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  const table= tables[selectedTableId];

  const [columnTitles, setColumnTitles] = useState(
    table.columns.reduce((acc, column) => {
      acc[column.column_id] = column.column_name;
      return acc;
    }, {})
  );

  const [tableTitle, setTableTitle] = useState(table.table_name);

  let rowIds=[];

  const handleDataChange = (newValue, columnId, rowIndex, rowId) => {

    const updatedData = { ...tableColumnData };  // Create a copy of the current state
    updatedData[columnId].data[rowIndex] = newValue; // Update the specific cell value
    setTableColumnData(updatedData); // ONLY FOR SPECIAL COLUMN AUTO-UPDATE

  // Make an API call to update the data in the database
    axios.post(`${API_BASE_URL}/update-data`, {
      columnId,
      rowId: rowId,
      newData: newValue
    }, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    })
    .then(response => {
      console.log('Data updated successfully:', response.data);
    })
    .catch(error => {
      console.error('Error updating data:', error);
    });
  };

  const addNewRow = (rowId) => {

    const newRowData = {}; // Object to store data for the new row

    table.columns.forEach(column => {
    newRowData[column.column_id] = '';
  });

    // Make an API request to add the new row
    axios.post(`${API_BASE_URL}/add-row`, {
      rowData: newRowData,
      previousRowId: rowId
    }, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    })
    .then(response => {
      console.log('Row added successfully:', response.data);

      fetchData(`${API_BASE_URL}/column-data/${projectId}`, setTableColumnData, setIsLoaded, 'columnData');
    })
    .catch(error => {
      console.error('Error adding row:', error);
    });

  };

  const removeRow = (rowId, rowin) => {

    // Create a copy of the current state
    const updatedData = { ...tableColumnData };

    // Remove the row at the specified index for each column
    Object.keys(updatedData).forEach(columnId => {
      updatedData[columnId].data.splice(rowin, 1);
      updatedData[columnId].row_id.splice(rowin, 1);
    });

    // Update the state with the new data
    setTableColumnData(updatedData);

    // Make an API call to remove the row from the database
  axios.post(`${API_BASE_URL}/remove-row`, {
    rowId: rowId,
    columnIds: table.columns.map(column => column.column_id)
  }, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  })
  .then(response => {
    console.log('Row removed successfully from the database:', response.data);
  })
  .catch(error => {
    console.error('Error removing row from the database:', error);
  });
};

  const removeColumn = (columnId) => {

  const updatedTable = { ...table, columns: table.columns.filter(column => column.column_id !== columnId) };
    const updatedTables = { ...tables, [selectedTableId]: updatedTable };
    setTables(updatedTables);

  // Make an API call to remove the column from the database
  axios.post(`${API_BASE_URL}/remove-column`, {
    columnId: columnId
  }, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  })
  .then(response => {
    console.log('Column removed successfully from the database:', response.data);
  })
  .catch(error => {
    console.error('Error removing column from the database:', error);
  });
};

  const handleTitleChange = (newTitle, columnId) => {
    setColumnTitles(prevTitles => ({
      ...prevTitles,
      [columnId]: newTitle,
    }));

    axios.post(`${API_BASE_URL}/update-column-title`, {
      columnId,
      newTitle,
    }, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      }
    })
      .then(response => {
        console.log('Column title updated successfully:', response.data);
      })
      .catch(error => {
        console.error('Error updating column title:', error);
      });
  };

  const addNewColumn = (columnId, columnName, formula) => {

    const newColumnName = columnName || prompt('Enter the name for the new column:');

    if (!newColumnName) return;

    axios.post(`${API_BASE_URL}/add-column`, {
      tableId: table.table_id,
      previousColumnId: columnId,
      columnName: newColumnName,
      formula:formula,
    }, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      }
    })
      .then(response => {
        console.log('Column added successfully:', response.data);

        const newColumnId = response.data.columnId;

        fetchData(`${API_BASE_URL}/column-data/${projectId}`, setTableColumnData, setIsLoaded, 'columnData');

        fetchData(`${API_BASE_URL}/tables/${projectId}`, setTables, setIsLoaded, 'tables');

        setColumnTitles(prevTitles => ({
          ...prevTitles,
          [newColumnId]: newColumnName,
        }));
      })
      .catch(error => {
        console.error('Error adding column:', error);
      });
  };

  const handleTableTitleChange = (newTitle) => {
    setTableTitle(newTitle);

    axios.post(`${API_BASE_URL}/update-table-title`, {
      tableId: table.table_id,
      newTitle,
    }, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      }
    })
    .then(response => {
      console.log('Table title updated successfully:', response.data);
    })
    .catch(error => {
      console.error('Error updating table title:', error);
    });
  };

  const InputCell = ({ value, columnId, rowIndex, rowId, onUpdate, tablePermission }) => {
  const [localValue, setLocalValue] = useState(value);

  const handleChange = (e) => {
    setLocalValue(e.target.value);
  };

  const handleBlur = () => {
    if (tablePermission !== 'read-only') {
      onUpdate(localValue, columnId, rowIndex, rowId);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && tablePermission !== 'read-only') {
      onUpdate(localValue, columnId, rowIndex, rowId);
    }
  };

  return (
    <input
      className="input-textbox"
      type="text"
      value={localValue}
      onChange={handleChange}
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
      style={{
        cursor: tablePermission === 'read-only' ? 'not-allowed' : 'text',
        //opacity: tablePermission === 'read-only' ? 0.5 : 1                // Change opacity if read-only
      }}
      disabled={tablePermission === 'read-only'}  // Disable input if read-only
    />
  );
};

  const InputCellColumnTitles = ({ value, columnId, onUpdate, tablePermission }) => {
  const [localValue, setLocalValue] = useState(value);

  const handleChange = (e) => {
    setLocalValue(e.target.value);
  };

  const handleBlur = () => {
    if (tablePermission !== 'read-only') {
      onUpdate(localValue, columnId);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && tablePermission !== 'read-only') {
      onUpdate(localValue, columnId);
    }
  };


  return (
    <input
      className="input-textbox"
      type="text"
      value={localValue}
      onChange={handleChange}
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
      style={{
        cursor: tablePermission === 'read-only' ? 'not-allowed' : 'text',  // Change cursor if read-only
        //opacity: tablePermission === 'read-only' ? 0.5 : 1                // Change opacity if read-only
      }}
      disabled={tablePermission === 'read-only'}  // Disable input if read-only
    />
  );
};

  const InputCellTitle = ({ value, onUpdate, tablePermission }) => {
  const [localValue, setLocalValue] = useState(value);

  const handleChange = (e) => {
    setLocalValue(e.target.value);
  };

  const handleBlur = () => {
    if (tablePermission !== 'read-only') {
      onUpdate(localValue);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && tablePermission !== 'read-only') {
      onUpdate(localValue);
    }
  };

  return (
    <input
      className="table-title-input"
      type="text"
      value={localValue}
      onChange={handleChange}
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
      style={{
        cursor: tablePermission === 'read-only' ? 'not-allowed' : 'text',
        //opacity: tablePermission === 'read-only' ? 0.5 : 1
      }}
      disabled={tablePermission === 'read-only'}  // Disable input if read-only
    />
  );
};


  const HealthDataTable = ({ tableData }) => {
    const columns = tableData.columns;

    // Sort columns by column_order before rendering
  columns.sort((a, b) => a.column_order - b.column_order);

    const getColumnData = columnId => {
      return tableColumnData[columnId] ? tableColumnData[columnId].data : [];
    };

    const firstColumnId = columns[0].column_id;
rowIds = tableColumnData[firstColumnId]?.row_id || [];

const IconButton = ({ Icon, action, tableId, permission }) => {
  const isReadOnly = permission === 'read-only';

  return (
    <Icon
      onClick={() => !isReadOnly && action(tableId)}
      style={{
        cursor: isReadOnly ? 'not-allowed' : 'pointer',
        opacity: isReadOnly ? 0.5 : 1
      }}
      disabled={isReadOnly}
    />
  );
};

  const handleSecondColumnSelect = (columnId) => {

    const newColumnName = `⭐ ${selectedColumnId === 'x' ? customValue : columnTitles[selectedColumnId]} ${selectedOperator} ${columnTitles[columnId]}`;
    const firstPart = selectedColumnId === 'x' ? customValue : 'C' + selectedColumnId;
    const lastParameter = firstPart + selectedOperator + 'C' + columnId;
    addNewColumn(columns[columns.length - 1].column_id, newColumnName, lastParameter);

    setSelectedColumnId(null);
    setSelectedOperator(null);
    setCustomValue('');
    setShowModal(false);
};

const handleTransposeColumnSelect = async (columnId) => {

  try {
    setSpinnerMessage('A Transpor...');
    setIsDuplicating(true); // Set the flag to indicate duplication process started

    const token = localStorage.getItem('token');
    const response = await axios.post(`${API_BASE_URL}/transpose/${selectedTableId}`,
  {
    pivotColumnId: pivotColumnId,
    groupingColumnId: groupingColumnId,
    grouping: grouping,
    method: method,
    columnId: columnId
  }, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

  const transposedItem = response.data[`transposedTable`];
  setTables({...tables, ...transposedItem});

  setIsDuplicating(false);
  setSpinnerMessage(null);

  } catch (error) {
    setIsDuplicating(false);
    setSpinnerMessage(null);
    console.error(`Error transposing`, error);
  }

  fetchData(`${API_BASE_URL}/column-data/${projectId}`, setTableColumnData, setIsTableColumnDataLoaded, 'columnData');

    setPivotColumnId(null);
    setGroupingColumnId(null);
    setShowModal2(false);
};

    return (
      <>
      <div className="project-info">
            <span>{""}</span>
      <div className="icons-container">

      <button
  onClick={() => {
    setShowModal2(true);
  }}
  style={{
    padding: "10px 20px",
    backgroundColor: table.permission === "read-only" ? "#6c757d" : "#007bff",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: table.permission === "read-only" ? "not-allowed" : "pointer",
    opacity: table.permission === "read-only" ? 0.5 : 1,
  }}
  disabled={table.permission === "read-only"} // Disable button if permission is read-only
>
  Transpor
</button>

<button
  onClick={() => {
    setShowModal(true);
  }}
  style={{
    padding: "10px 20px",
    backgroundColor: table.permission === "read-only" ? "#6c757d" : "#007bff",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: table.permission === "read-only" ? "not-allowed" : "pointer",
    opacity: table.permission === "read-only" ? 0.5 : 1,
  }}
  disabled={table.permission === "read-only"} // Disable button if permission is read-only
>
  Coluna Especial
</button>



    {showModal && (
        <div className="modal_formula">
          <div className="modal_formula-content">
            <span className="close_formula" onClick={() => {setSelectedColumnId(null);
    setSelectedOperator(null);
    setCustomValue('');
    setShowModal(false);}}>&times;</span>

{!selectedColumnId && (<>
            <h4>Select a column:</h4>
            {/* Custom value input */}
            <div className="custom-group">
            <input
              type="text"
              value={customValue}
              onChange={(e) => setCustomValue(e.target.value)}
              placeholder="Enter custom value"
            />
            <button onClick={() => {setSelectedColumnId('x');}}>
              Select Custom Value
            </button>
            </div>

            {/* Scrollable list of columns */}

            <div className="scrollable-formula-list">
              <ul>
                {Object.keys(columnTitles).map(columnId => (
                  <li key={columnId}>
                    <button onClick={() => {setSelectedColumnId(columnId);}}>
                      {columnTitles[columnId]}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
</>)}

            {/* Operator selection */}
            {selectedColumnId && !selectedOperator && (
              <div>
                <h4>Select an operator:</h4>
                <div className="scrollable-formula-list">
                  <ul>
                    {['+', '-', '*', '/'].map(operator => (
                      <li key={operator}>
                        <button onClick={() => {setSelectedOperator(operator);}}>
                          {operator}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )}

            {/* Second column selection */}
            {selectedOperator && (
              <div>
                <h4>Select a second column:</h4>
                <div className="scrollable-formula-list">
                  <ul>
                    {Object.keys(columnTitles).map(columnId => (
                      <li key={columnId}>
                        <button onClick={() => handleSecondColumnSelect(columnId)}>
                          {columnTitles[columnId]}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {showModal2 && (
        <div className="modal_formula">
          <div className="modal_formula-content">
            <span className="close_formula"
            onClick={() => {
              setPivotColumnId(null);
              setGroupingColumnId(null);
              setMethod(null);
              setShowModal2(false);
            }}
    >&times;</span>

{!pivotColumnId && (
  <>
            <h4>Pivot column:</h4>
            <div className="scrollable-formula-list">
              <ul>
                {Object.keys(columnTitles).map(columnId => (
                  <li key={columnId}>
                    <button onClick={() => {setPivotColumnId(columnId);}}>
                      {columnTitles[columnId]}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
</>

)}

            {pivotColumnId && !groupingColumnId && (
<>
            <h4>Grouping column:</h4>
<div className="scrollable-formula-list">
  <ul>
    {/*
    <li key="complete-table">
      <button onClick={() => { setGroupingColumnId(1); setGrouping(false); }}>
        Tabela completa
      </button>
    </li>
    */}
    {Object.keys(columnTitles).map(columnId => (
      <li key={columnId}>
        <button onClick={() => { setGroupingColumnId(columnId); setGrouping(true); }}>
          {columnTitles[columnId]}
        </button>
      </li>
    ))}
  </ul>
</div>

</>
            )}

            {pivotColumnId && groupingColumnId && !method && (
<>
            <h4>Método de Cálculo:</h4>
<div className="scrollable-formula-list">
  <ul>
  {['Soma', 'Média', 'Máximo', 'Mínimo', 'Contagem'].map((label, index) => (
    <li key={index}>
      <button onClick={() => setMethod(index + 1)}>
        {label}
      </button>
    </li>
  ))}
</ul>

</div>

</>
            )}

            {/* Second column selection */}
            {pivotColumnId && groupingColumnId && method && (
              <div>
                <h4>Values to agregate column:</h4>
                <div className="scrollable-formula-list">
                  <ul>
                    {Object.keys(columnTitles).map(columnId => (
                      <li key={columnId}>
                        <button onClick={() => handleTransposeColumnSelect(columnId)}>
                          {columnTitles[columnId]}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

<IconButton
  Icon={SaveIcon}
  action={onSave}
  tableId={table.table_id}
  permission={table.permission}
/>

<IconButton
  Icon={CopyIcon}
  action={onDuplicate}
  tableId={table.table_id}
  permission={table.permission}
/>

<IconButton
  Icon={TrashIcon}
  action={onDelete}
  tableId={table.table_id}
  permission={table.permission}
/>

                <ExportIcon
                  onClick={() => onExport(table.table_id)}
                  style={{ cursor: 'pointer' }}
                />
            </div>
            </div>

      <div className="table-container">

              <InputCellTitle
                  value={tableTitle}
                  onUpdate={handleTableTitleChange}
                  tablePermission={table.permission}
                />

        <table className="custom-table">
          <thead>

    {/* Row for column management icons ****************************************************/}
    <tr className="icon-row">
    <th className="icon-row"></th> {/* New yellow column */}
      <th className="icon-row">

          <PlusIcon
  onClick={() => {
    if (table.permission !== 'read-only') {
      addNewColumn(null);
    }
  }}
  style={{
    cursor: table.permission === 'read-only' ? 'not-allowed' : 'pointer',
    opacity: table.permission === 'read-only' ? 0.5 : 1
  }}
  disabled={table.permission === 'read-only'}
/>

      </th> {/* Empty cell for row number */}
      {columns.map(column => (
        <th key={column.column_id} className="icon-row">
          <PlusIcon
  onClick={() => {
    if (table.permission !== 'read-only') {
      addNewColumn(column.column_id);
    }
  }}
  style={{
    cursor: table.permission === 'read-only' ? 'not-allowed' : 'pointer',  // Grey out if read-only
    marginRight: '10px',
    opacity: table.permission === 'read-only' ? 0.5 : 1                   // Adjust opacity if read-only
  }}
  disabled={table.permission === 'read-only'}  // Disable the button if read-only
/>

<MinusIcon
  onClick={() => {
    if (table.permission !== 'read-only') {
      removeColumn(column.column_id);
    }
  }}
  style={{
    cursor: table.permission === 'read-only' ? 'not-allowed' : 'pointer',  // Grey out if read-only
    opacity: table.permission === 'read-only' ? 0.5 : 1                   // Adjust opacity if read-only
  }}
  disabled={table.permission === 'read-only'}  // Disable the button if read-only
/>

        </th>
      ))}
    </tr>
{/***** Row for titles ***************************************************************************/}

            <tr className="table-header-row">
<th>

            <PlusIcon
  onClick={() => {
    // Only allow adding a new row if the table permission is not 'read-only'
    if (table.permission !== 'read-only') {
      addNewRow(0);
    }
  }}
  style={{
    cursor: table.permission === 'read-only' ? 'not-allowed' : 'pointer',  // Grey out if read-only
    marginLeft: '10px',
    opacity: table.permission === 'read-only' ? 0.5 : 1                   // Adjust opacity if read-only
  }}
  disabled={table.permission === 'read-only'}  // Disable the button if read-only
/>


</th>
<th className="table-header-cell">#</th> {/* Add header for row numbers */}

            {columns.map(column => (

<th key={column.column_id} className="table-header-cell">

                  <InputCellColumnTitles
                  value={columnTitles[column.column_id]}
                  columnId={column.column_id}
                  onUpdate={handleTitleChange}
                  tablePermission={table.permission}
                />
                </th>
              ))}
            </tr>
{/***************************************************************************************/}
          </thead>
          <tbody>

          {rowIds.map((rowId, rowIndex) => (
  <tr key={rowId} className="table-row">
<td>
<div style={{ display: 'flex', alignItems: 'center' }}>
            <PlusIcon
  onClick={() => {
    // Only allow adding a new row if the table permission is not 'read-only'
    if (table.permission !== 'read-only') {
      addNewRow(rowId);
    }
  }}
  style={{
    cursor: table.permission === 'read-only' ? 'not-allowed' : 'pointer',  // Grey out if read-only
    marginRight: '10px',
    opacity: table.permission === 'read-only' ? 0.5 : 1                   // Adjust opacity if read-only
  }}
  disabled={table.permission === 'read-only'}  // Disable the button if read-only
/>

<MinusIcon
  onClick={() => {
    // Only allow removing a row if the table permission is not 'read-only'
    if (table.permission !== 'read-only') {
      removeRow(rowId, rowIndex);
    }
  }}
  style={{
    cursor: table.permission === 'read-only' ? 'not-allowed' : 'pointer',  // Grey out if read-only
    opacity: table.permission === 'read-only' ? 0.5 : 1                   // Adjust opacity if read-only
  }}
  disabled={table.permission === 'read-only'}  // Disable the button if read-only
/>

              </div>
</td>
<td className="table-cell">{rowIndex + 1}</td> {/* Add row number */}
                {columns.map(column => (
                  <td key={column.column_id} className="table-cell">

                <InputCell
                  value={getColumnData(column.column_id)[rowIndex] || ''}
                  columnId={column.column_id}
                  rowIndex={rowIndex}
                  rowId={rowId}
                  onUpdate={handleDataChange}
                  tablePermission={table.permission}
                />
                  </td>
                ))}


              </tr>
            ))}
          </tbody>
        </table>
      </div>
      </>
    );
  };

  return (
    <div>
      <HealthDataTable tableData={table} />
    </div>
  );
}

export default TableViewer;
